import { combineReducers } from 'redux';
import { createReducer } from 'utils';
import types from './types';

const createEntityReducer = entity =>
  createReducer(
    {},
    {
      [types.MERGE_ENTITIES]: (state, action) =>
        action.payload[entity]
          ? { ...state, ...action.payload[entity] }
          : state,
    }
  );

const entityNames = [
  'amenity',
  'city',
  'cuisine',
  'eatery',
  'tag',
  'tip',
  'user',
];

const reducers = entityNames.reduce((reducers, entity) => {
  reducers[entity] = createEntityReducer(entity);
  return reducers;
}, {});

const entities = combineReducers(reducers);

export default {
  entities,
};
